import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, Outlet} from 'react-router-dom'

import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {isAuthorizedUser} from './utils/permissions'
import {useAuth} from '../modules/auth'

import {MasterLayout} from '../../_metronic/layout/Kpi/MasterLayout'
import ReportSalePage from '../../pages/kpi/reports/reportSale/list'
import ReportSalePageDetail from '../../pages/kpi/reports/reportSaleDetail/list'
import ReportUserPageDetail from '../../pages/kpi/reports/reportUserDetail/list'
import ReportClientePage from '../../pages/kpi/reports/reportCliente/list'
import ReportTransferPage from '../../pages/kpi/reports/reportTransfer/list'
import ReportSummaryPage from '../../pages/kpi/reports/reportSummary'
import ReportRecurrencePage from '../../pages/kpi/reports/reportRecurrence/list'
import ReportBonusSalePage from '../../pages/kpi/reports/reportBonusSale/list'
import ReportBonusSaleDetailPage from '../../pages/kpi/reports/reportBonusSaleDetail/list'
import ReportDownloadsKpiPage from '../../pages/kpi/reports/reportDownloads/list'
import {DashboardPage} from '../../pages/kpi/dashboard'
import ReportUserPage from '../../pages/kpi/reports/reportUser/list'
import UserProfilePage from '../../pages/kpi/userProfile'

const PermissionsGuard = ({permission}: {permission: string}) => {
  const {currentUser, currentFranchise} = useAuth()
  const isAuthorized = isAuthorizedUser(currentUser, permission)

  return isAuthorized ? <Outlet /> : <Navigate to='/error/404' />
}

const PrivateKpiRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='dashboard' element={<DashboardPage />} />

        {
          // RELATÓRIOS
        }

        <Route element={<PermissionsGuard permission='kpi.sales' />}>
          <Route path='reports/reportSale/list' element={<ReportSalePage />} />
        </Route>

        <Route element={<PermissionsGuard permission='kpi.sale_items' />}>
          <Route path='reports/reportSaleDetail/list' element={<ReportSalePageDetail />} />
        </Route>

        <Route element={<PermissionsGuard permission='kpi.salesman' />}>
          <Route path='reports/reportUser/list' element={<ReportUserPage />} />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.sales_by_day' />}>
          <Route path='reports/reportUserDetail/list' element={<ReportUserPageDetail />} />
        </Route>

        <Route element={<PermissionsGuard permission='kpi.customers' />}>
          <Route path='reports/reportCliente/list' element={<ReportClientePage />} />
        </Route>

        <Route element={<PermissionsGuard permission='kpi.transfers' />}>
          <Route path='reports/reportTransfer/list' element={<ReportTransferPage />} />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.summary' />}>
          <Route path='reports/reportSummary/list' element={<ReportSummaryPage />} />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.recurrence' />}>
          <Route path='reports/reportRecurrence/list' element={<ReportRecurrencePage />} />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.bonus_sales' />}>
          <Route path='reports/reportBonusSale/list' element={<ReportBonusSalePage />} />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.bonus_sale_items' />}>
          <Route
            path='reports/reportBonusSaleDetail/list'
            element={<ReportBonusSaleDetailPage />}
          />
        </Route>
        <Route element={<PermissionsGuard permission='kpi.export' />}>
          <Route path='reports/downloads' element={<ReportDownloadsKpiPage />} />
        </Route>

        <Route path='userProfile' element={<UserProfilePage />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateKpiRoutes}
